import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-primary via-primary to-primary-dark text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/cec408eade00b7f2bb8d035c2ad6c56f.png"
                alt="روافع المتحدون للمقاولات"
                className="h-16 w-auto object-contain brightness-0 invert"
              />
            </div>
            <p className="text-white/80 leading-relaxed mb-6">
              شركة سعودية رائدة في تأجير الرافعات والمعدات الإنشائية مع خبرة تزيد عن 15 عاماً
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-twitter-x-fill', link: '#' },
                { icon: 'ri-linkedin-fill', link: '#' },
                { icon: 'ri-instagram-fill', link: '#' },
                { icon: 'ri-facebook-fill', link: '#' },
              ].map((social, index) => (
                <a
                  key={index}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-accent rounded-lg transition-all hover:scale-110 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg text-white`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-accent">روابط سريعة</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-accent transition-colors text-sm cursor-pointer">
                  الرئيسية
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-accent transition-colors text-sm cursor-pointer">
                  من نحن
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-accent transition-colors text-sm cursor-pointer">
                  خدماتنا
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-accent">خدماتنا</h3>
            <ul className="space-y-3">
              <li className="text-gray-300 text-sm">تأجير الرافعات الهيدروليكية</li>
              <li className="text-gray-300 text-sm">تأجير المعدات الإنشائية</li>
              <li className="text-gray-300 text-sm">الصيانة والإصلاح</li>
              <li className="text-gray-300 text-sm">النقل والتوصيل</li>
              <li className="text-gray-300 text-sm">توفير مشغلين محترفين</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-6 text-accent">تواصل معنا</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-map-pin-fill text-accent"></i>
                </div>
                <span className="text-gray-300 text-sm">الرياض، المملكة العربية السعودية</span>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-phone-fill text-accent"></i>
                </div>
                <a href="tel:920000000" className="text-gray-300 hover:text-accent text-sm cursor-pointer">
                  920000000
                </a>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-mail-fill text-accent"></i>
                </div>
                <a href="mailto:info@rawafee.sa" className="text-gray-300 hover:text-accent text-sm cursor-pointer">
                  info@rawafee.sa
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 روافع المتحدون للمقاولات. جميع الحقوق محفوظة
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-accent text-sm transition-colors cursor-pointer"
            >
              Powered by  AAIT
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;